import React,{useState,useEffect} from 'react'
import TopHeader from './subcomponents/TopHeader'
import BottomFooter from './subcomponents/BottomFooter';
import { Box,Paper, Typography, Button,Slide } from "@mui/material";
import { TextField , Container} from "@mui/material";
import Grid from "@mui/material/Grid2";
function ContactLensReorderPage() {
     const [clinicData, setClinicData] = useState({
      clinicName: "Delta Eye Clinic",
      primaryColor: "#E3F2FD",
      secondaryColor: "#00796B",
      logo: "https://www.eyeconx.net/clinic/templates/logos/delta_eye_logo.png",
      address: "123 Main Street, Cityville, ST 12345",
      phone: "(123) 456-7890",
      fax: "(123) 456-7899",
      backgroundImage: "https://source.unsplash.com/1600x900/?medical,clinic", // Sample background image
    });
     const [formData, setFormData] = useState({
      firstName: "",
      lastName: "",
      preferredName: "",
      email: "",
      cellPhone: "",
      homePhone: "",
      street: "",
      apt: "",
      city: "",
      province: "",
      postalCode: "",
      country: "",
    });
     useEffect(() => {
         const demoData = {
           clinicName: "Delta Eye Clinic",
           primaryColor: "#E3F2FD",
           secondaryColor: "#00796B",
           logo: "https://www.eyeconx.net/clinic/templates/logos/delta_eye_logo.png",
           address: "123 Main Street, Cityville, ST 12345",
           phone: "(123) 456-7890",
           fax: "(123) 456-7899",
           backgroundImage: "https://source.unsplash.com/1600x900/?medical,clinic", // Sample background image
         };
         setClinicData(demoData);
         // Simulate API call
         /*fetch("/api/clinic-theme") // Replace with actual API endpoint
           .then((res) => res.json())
           .then((data) => setClinicData(data))
           .catch((err) => console.error("Error fetching clinic data:", err));*/
       }, []);
       const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      };
       const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form Data Submitted:", formData);
      };
  return (
    <>
     <Box
      sx={{
       
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        padding: 3,
      }}
    >
        {clinicData && <TopHeader clinicData={clinicData} />}
        {/* Form Section */}
              <Slide direction="up" in={true} mountOnEnter unmountOnExit>
                 <Paper
                    elevation={4}
                    sx={{
                        padding: 4,
                        maxWidth: "lg",
                        width: "100%",
                        borderRadius: 3,
                        textAlign: "center",
                        backgroundColor: "#fff",
                        boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.15)",
                        marginTop: { xs: 5, md: 14 },
                    }}
                    >
                        <Typography variant="h5"  sx={{ mb: 3, fontWeight: "bold", color: clinicData.secondaryColor }}>
                            Contact Lens Reorder
                        </Typography>
                        <Typography variant="body1"  sx={{ mb: 3, fontWeight: "bold", color: clinicData.secondaryColor }}>
                            Please call us at 000000000000 to reorder your contact lenses.
                        </Typography>
                        <Container maxWidth="sm">
                        <form onSubmit={handleSubmit}>
                          <Grid container spacing={{ xs: 2, sm: 2 }}>
                            <Grid size={{xs:12,md:6}}>
                              <TextField fullWidth label="First Name" name="firstName" value={formData.firstName} onChange={handleChange} required />
                            </Grid>
                            <Grid size={{xs:12,md:6}}>
                              <TextField fullWidth label="Last Name" name="lastName" value={formData.lastName} onChange={handleChange} required />
                            </Grid>
                            <Grid size={{xs:12,md:6}}>
                              <TextField fullWidth label="Preferred Name" name="preferredName" value={formData.preferredName} onChange={handleChange} />
                            </Grid>
                            <Grid size={{xs:12,md:6}}>
                              <TextField fullWidth label="Email" name="email" value={formData.email} onChange={handleChange} type="email" />
                            </Grid>
                            <Grid size={{xs:12,md:6}}>
                              <TextField fullWidth label="Cell Phone" name="cellPhone" value={formData.cellPhone} onChange={handleChange} type="tel" />
                            </Grid>
                            <Grid size={{xs:12,md:6}}>
                              <TextField fullWidth label="Home Phone" name="homePhone" value={formData.homePhone} onChange={handleChange} type="tel" />
                            </Grid>
                            <Grid size={{xs:12}}>
                              <Typography variant="h6">Address</Typography>
                            </Grid>
                            <Grid size={{xs:12,md:6}}>
                              <TextField fullWidth label="Street" name="street" value={formData.street} onChange={handleChange} required />
                            </Grid>
                            <Grid size={{xs:12,md:6}}>
                              <TextField fullWidth label="Apt/Suite" name="apt" value={formData.apt} onChange={handleChange} />
                            </Grid>
                            <Grid size={{xs:12,md:6}}>
                              <TextField fullWidth label="City" name="city" value={formData.city} onChange={handleChange} required />
                            </Grid>
                            <Grid size={{xs:12,md:6}}>
                              <TextField fullWidth label="Province" name="province" value={formData.province} onChange={handleChange} required />
                            </Grid>
                            <Grid size={{xs:12,md:6}}>
                              <TextField fullWidth label="Postal Code" name="postalCode" value={formData.postalCode} onChange={handleChange} required />
                            </Grid>
                            <Grid size={{xs:12,md:6}}>
                              <TextField fullWidth label="Country" name="country" value={formData.country} onChange={handleChange} required />
                            </Grid>
                            <Grid size={{xs:12}}>
                              <Button
                                           type="submit"
                                           variant="contained"
                                           fullWidth
                                           sx={{
                                             backgroundColor: clinicData.secondaryColor,
                                             color: "#fff",
                                             py: 1.5,
                                             fontSize: "16px",
                                             transition: "transform 0.2s ease-in-out",
                                             "&:hover": {
                                               transform: "scale(1.05)",
                                             },
                                           }}
                                         >
                                           Submit
                                         </Button>
                              </Grid>
                          </Grid>
                        </form>
                        </Container>
                      
                    </Paper>
              </Slide>
                           
                            </Box>
                            {clinicData && <BottomFooter clinicData={clinicData} />}
    </>
  )
}

export default ContactLensReorderPage